import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { EmployeeService } from '@services/employee/employee.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NbToastrService } from '@nebular/theme';

@Injectable()
export class ApiApexInterceptor implements HttpInterceptor {
  newRequest: HttpRequest<unknown>;
  httpRequestCount = 0;
  
  constructor(private spinnerService: NgxSpinnerService, private toastrService: NbToastrService) { }
  
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const employee = inject(EmployeeService).getEmployeeByLocalStorage()
    
    
    this.httpRequestCount++;
    if (employee) {
      this.spinnerService.show("loader")
      
      const legajo = request.headers.has('legajo') ? request.headers.get('legajo') : employee.legajo;
      const puesto = request.headers.has('puesto') ? request.headers.get('puesto') : employee.idPuesto;

      this.newRequest = request.clone({
        headers: request.headers
          .set('legajo', legajo)
          .set('account', employee.idCuenta)
          .set('puesto', puesto)
      })
    }

    const requestHandle = employee ? this.newRequest : request;
    return next.handle(requestHandle).pipe(
      tap((event: HttpEvent<any>) => {
        if (event) {
          // Aquí puedes acceder a la respuesta de la API
          console.log('API Response:', event);
          console.log('API Response:', event);
        }
      }),
      finalize(() =>
      {
          this.httpRequestCount--;
          if (!this.httpRequestCount) {
              this.spinnerService.hide("loader");
          }
      }
    ),
    catchError((error) => {
      console.log(error)
        const maxMessageLength = 90
        const preventDuplicates = true;
        const status = 'danger';
        const errorMessage = error.message.length > maxMessageLength
      ? error.message.substring(0, maxMessageLength) + '...'
      : error.message;
        this.toastrService.show(
          errorMessage,
          error.name,
          { preventDuplicates, status });
      
        return throwError(()=>error);
    })

    
    );
    ;
  }
}
